/**
 * Punto de entrada.
 *
 * Cada módulo expone un init() idempotente que sale sin hacer nada si su
 * marcado no está en la página. Un error en uno no puede tumbar al resto.
 */

import * as nav from './modules/nav.js';
import * as carousel from './modules/carousel.js';
import * as videos from './modules/videos.js';
import * as reels from './modules/reels.js';
import * as form from './modules/form.js';
import * as reveal from './modules/reveal.js';
import * as motion from './modules/motion.js';
import { CONTACT } from './config.js';

const MODULES = [
  ['nav', nav],
  ['carousel', carousel],
  ['videos', videos],
  ['reels', reels],
  ['form', form],
  ['reveal', reveal],
  ['motion', motion],
];

/** Completa los links de contacto desde config.js, sin duplicar el dato. */
function hydrateContactLinks() {
  const wa = `https://api.whatsapp.com/send?phone=${CONTACT.whatsapp}`;
  document.querySelectorAll('[data-link="whatsapp"]').forEach((el) => {
    el.href = wa;
  });
  document.querySelectorAll('[data-link="email"]').forEach((el) => {
    el.href = `mailto:${CONTACT.email}`;
  });
  document.querySelectorAll('[data-link="instagram"]').forEach((el) => {
    el.href = CONTACT.instagram;
  });
}

/** Mantiene el año del footer al día sin tener que editar el HTML. */
function updateYear() {
  const year = String(new Date().getFullYear());
  document.querySelectorAll('[data-year]').forEach((el) => {
    el.textContent = year;
  });
}

function boot() {
  // La clase no-js del <html> se saca ya en el <head>; esto es por si
  // el script de arranque no llegó a correr.
  document.documentElement.classList.remove('no-js');

  hydrateContactLinks();
  updateYear();

  MODULES.forEach(([name, mod]) => {
    try {
      mod.init();
    } catch (err) {
      console.error(`[serendipia] falló el módulo "${name}":`, err);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
